import { AfterContentChecked, ChangeDetectorRef, Component, ElementRef, HostListener, OnDestroy, OnInit, ViewChild, ChangeDetectionStrategy } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { TabPosition, TabStripTabComponent } from '@progress/kendo-angular-layout';
import { environment } from 'environments/environment';
import { Observable, BehaviorSubject } from 'rxjs';
import { debounceTime, distinctUntilChanged } from 'rxjs/operators';
import { GridColumnMap } from '~/front-models/gridColumnMap';
import { DataWithPagingMetadata } from '~/infrastructure/paging';
import { AccountSummary, RelationAccount } from '~/models/administration/account';
import { GridFieldAuthorization } from '~/models/administration/securityLevel';
import { UserSummary } from '~/models/administration/user';
import { Chart } from '~/models/chart/chart';
import { CategorySummary } from '~/models/modules/category';
import { CategoryFile } from '~/models/modules/categoryFile';
import { CustomFieldSummary } from '~/models/modules/customField';
import { GridFieldSummary } from '~/models/modules/gridField';
import { GridFieldTextSummary } from '~/models/modules/GridFieldText';
import { StartEndDateChartResponseModel } from '~/models/modules/startEndDateChartResponseModel';
import { AccountsService } from '~/services/administration.ts/accounts';
import { BarcodeGeneratorsService } from '~/services/modules/stocks/barcode-generators';
import { CategoriesService } from '~/services/modules/stocks/categories';
import { CustomFieldsService } from '~/services/modules/stocks/custom-fields';
import { FilesService } from '~/services/modules/stocks/files';
import { GridFieldsService } from '~/services/modules/stocks/gridField';
import { StockItemsService } from '~/services/modules/stocks/items';
import { ReceiveTransactionsService } from '~/services/modules/stocks/receive-transactions';
import { SecurityService } from '~/services/security.service';
import { SharedService } from '~/services/sharedService';
import { ThemeManagerService } from '~/services/theme-manager';
import { GridLayoutManagerService } from '~/shared/components/grid/layout/grid-layout-manager';
import { LayoutManagerService } from '~/shared/components/layout/layout-manager';
import { LayoutComponent } from '~/shared/components/layout/layout.component';
import { PageState } from '~/shared/enums/stock-files.enum';
import { NoteComponent } from '~/shared/components/note/note.component';
import { EntityStatusOptions } from '~/models/entityStatus';
import { GDataService } from '~/services/GDataService';
import { EnvironmentLoaderService } from '~/services/BackEndURL/environment-loader.service';
import { fileSources } from '~/shared/enums/fileSources';
import { MultiSiteAwareComponent } from '~/infrastructure/multi-site-aware.component';
import { ActivatedRoute } from '@angular/router';

@Component({
    selector: 'categories-form',
    templateUrl: './upsert.html',
    styleUrls: ['./upsert.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class StocksCategoriesUpsertComponent
  extends MultiSiteAwareComponent
  implements OnInit, OnDestroy, AfterContentChecked {
  _currentUser: UserSummary;
  _kendoTabStripPosition: TabPosition = 'left';
  _innerWidth: any;
  _hiddenWindow: any;
  _maximized: any;
  _accountColumnsMap: GridColumnMap[] = [];
  _imageColumnsMap: GridColumnMap[] = [];
  _accounts: AccountSummary[];
  _selectedAccounts: any[] = [];
  _selectedImages: any[] = [];
  _selectedImagesKeys: number[] = [];
  _theme: string;
  _isNew: boolean;
  _form: FormGroup;
  _active: boolean;
  _active2: boolean
  _listbarcodegenerator: Array<any> = [];
  _isAutoGeneratingNumber: boolean;
  _showImagesGrid: boolean;
  declare _tabEnabled: boolean;
  _invalidForm: boolean;
  _custominvalidForm: boolean;
  _invalidSubmit: boolean;
  _model: CategorySummary = null;
  _categoryCode = new FormControl();
  _pageState: PageState;
  _showCirclesForm: boolean;
  _tooltipVisibilityUpsert: boolean = true;
  _tooltipVisibilityForm: boolean = true;
  _addClassActive: boolean = false;
  _editFormActive: boolean;
  _isCustomfieldsFormValue: boolean = false;
  _isAddTabFormValue: boolean = false;
  _isRenameFormValue: boolean = false;
  _selectedTabId: number;
  _selectedAccountIds: any[] = [];
  _customValidation: any = [];
  _imageSearchControl = new FormControl();
  _imageSearchResult: string;
  _deactivatedFormTabsForm: boolean = false
  _deactivatedFormTabsGridData: Array<any> = [];

  _customFields: CustomFieldSummary[][] = [];
  _customFieldsValue: any = [];
  _customFieldsDictionary: { [key: string]: string } = {};
  _selectedLabelId: number;
  _customTabs: any;
  _page = 'categories';
  _permissionScope = 'categories';
  _gridFieldText: GridFieldTextSummary[];
  _language: string = 'en';
  _selectedLabelObjectCode: any;
  _isRenameCustomFormValue: boolean = false;
  _isRenameLabel: boolean = false;
  quantities = Array<any>();
  dates = Array<any>();

  _index: number;
  _systemFields: Array<any> = [];
  _requiredFields: Array<any> = [];
  _customRequiredFields: Array<any> = [];
  _requiredFieldNames: Array<any> = [];
  _editedSystemFields: Array<any> = [];
  _isEditForms: boolean = false;

  _selectedObjectImages: any[] = [];
  _stockItemFilesPics: CategoryFile[] = [];
  accessFrom: string;

  // #region Graphs
  /* public _donutChartSmall: any[] = [
    {
      data: [
        {
          category: 'Safe Workplace',
          value: 30,
          color: '#e7e0fc',
          colorLabel: '#321982',
          font: '8px -apple-system, BlinkMacSystemFont',
        },
        {
          category: 'DC Health',
          value: 40,
          color: '#d1c7f0',
          colorLabel: '#321982',
          font: '8px -apple-system, BlinkMacSystemFont',
        },
        {
          category: 'District Logistics',
          value: 120,
          color: '#b3a5e3',
          colorLabel: '#321982',
          font: '8px -apple-system, BlinkMacSystemFont',
        },
      ],
      sum: 180,
      title: 'Category(name)',
    },
  ]; */

  reactivate: boolean = false;
  reactivateItem: any;

  /* public _donutChartLarge: any[] = [
    {
      data: [
        {
          category: 'Safe Workplace',
          value: 30,
          color: '#e7e0fc',
          colorLabel: '#321982',
          font: '13px -apple-system, BlinkMacSystemFont',
        },
        {
          category: 'DC Health',
          value: 40,
          color: '#d1c7f0',
          colorLabel: '#321982',
          font: '13px -apple-system, BlinkMacSystemFont',
        },
        {
          category: 'District Logistics',
          value: 120,
          color: '#b3a5e3',
          colorLabel: '#321982',
          font: '13px -apple-system, BlinkMacSystemFont',
        },
      ],
      sum: 180,
      title: 'Category(name)',
    },
  ]; */
  // #endregion
  okCloseSubscription: any = null;
  _deactivatedFieldsForm: boolean = false;
  _deactivatedFieldsGridData: any[] = [];
  _SIQChartForm: boolean = false;
  _imageTabActive: boolean = false;
  _SIQActive: boolean = true;
  _showimageTab: boolean = false;
  listLocationQty: any;
  deactivatedFieldsGridData: any[] = [];
  urlAndStream: string;
  StockQtyInCategoryPerDate: Array<any> = [];
  _userNewDataTabs: Array<any> = [];
  _dataTabs: Array<any> = [];
  _dataTabsSelected: Array<any> = [];
  _orderingTabsForm: boolean = false;
  _gridFieldAuth: GridFieldAuthorization[];
  _isMandatory: boolean = false;
  _isLiveEnterprise: boolean;
  _isDialiogCategory: boolean = false;
  _dialogComponentName: string;
  _dialogModel: any;
  imageUrl: string;
  _receiveGridColumns: GridFieldSummary[];
  stockItemQuantityChartDetail: StartEndDateChartResponseModel;
  stockItemQuantityChart: Chart;
  stockItemQuantitySecondChart: Chart;
  isStockItemGridExpanded: boolean = true;
  isStockItemChartExpanded: boolean = true;
  _storagePath: string;
  _isOs: boolean;
  _filesPageName: string = 'files'
  _entity = 'stock'
  //#region  ViewChild
  @ViewChild('kendo_tabstrip_wrapper') navTrigger: ElementRef;
  @ViewChild('mainWindow') kendoMainWindow: ElementRef;
  @ViewChild('kendo_BarcodeGen_Category_Number')
  kendoBarcodeGenCategoryNumber: ElementRef;
  @ViewChild('kendo_Input_Category_Description')
  kendoInputCategoryDescription: ElementRef;
  @ViewChild('accountTab') accountTab: TabStripTabComponent;
  @ViewChild('stockItemQuantityTab') StockItemQuantityTab: TabStripTabComponent;
  @ViewChild('picturesTab') picturesTab: TabStripTabComponent;
  @ViewChild('ReceivePerCategoryTab')
  ReceivePerCategoryTab: TabStripTabComponent;
  @ViewChild('IssuePerCategoryTab') IssuePerCategoryTab: TabStripTabComponent;
  @ViewChild('MovePerCategoryTab') MovePerCategoryTab: TabStripTabComponent;
  @ViewChild('note') note: NoteComponent;
  copyModelId: number;
  _gridColumns: GridFieldSummary[];
  _gridColumnsDuplicate: GridFieldSummary[];
  behavior: BehaviorSubject<GridFieldSummary[]>;
  //#endregion

  //#region  CTOR
  constructor(private _accountsService: AccountsService,
    private _filesService: FilesService,
    private _categoriesService: CategoriesService,
    private _fb: FormBuilder,
    private _themeManager: ThemeManagerService,
    private _layoutManager: LayoutManagerService,
    private _gridLayoutManagerService: GridLayoutManagerService,
    private _layoutComponent: LayoutComponent,
    private _barcodeGeneratorsService: BarcodeGeneratorsService,
    private _securityService: SecurityService,
    private _customFieldsService: CustomFieldsService,
    private _gridFields: GridFieldsService,
    private _receieveTransactionService: ReceiveTransactionsService,
    public cdRef: ChangeDetectorRef,
    private _dataService: GDataService,
    private _sharedService: SharedService,
    private _gridLayoutManagerServicelocation: GridLayoutManagerService,
    private route: ActivatedRoute) {
    super();
    this._isLiveEnterprise = environment.liveEnterprise;

    this._getdata();

    this._themeManager.themeChange.subscribe((data) => {
      this._theme = data;
    });

    this._layoutManager.applyOverly();

    if (this._pageState == PageState.EDIT || this._pageState == PageState.VIEW) {
      this._selectedAccounts = (this._model?.categoryAccounts ?? []).map((x: any) => +(x.account?.id ?? x.accountId ?? x.id ?? x));
      this._selectedAccountIds = [...this._selectedAccounts];
      this._selectedImagesKeys = (this._model?.categoryFiles ?? []).map((x: CategoryFile) => +x.file?.id);

      this._tabEnabled = this._selectedAccounts.length > 0;
    }

    this._currentUser = this._securityService.currentUser;

    //this.loadCustomFields(this._model?.id?.toString());
    this.loadLabels();
    this._customFieldsService.getDeactivatedCustomFields('stock', this._page).subscribe((data: Array<any>) => {
      this._deactivatedFieldsGridData = data.filter((x) => x.formTab.page === this._page);
    });

    if (this._selectedImagesKeys.length === 0) {
      this._showimageTab = false;
    }
    else {
      this._showimageTab = true;
    }

    this._storagePath = EnvironmentLoaderService.envConfig.enterpriseApiLocal + '\\';

    if (window.navigator.userAgent.indexOf('Mac') != -1) {
      this._isOs = true;
    }

    this._imageSearchControl.valueChanges.pipe(debounceTime(700), distinctUntilChanged()).subscribe((q) => {
      this._imageSearchResult = q;
      // setTimeout(() => {
      //   this.imageSearchInput.nativeElement.focus();
      // }, 500);
    });
    this._gridFields.getGridFieldsByPage(this._filesPageName).subscribe((data: any) => {
      //this._gridColumns = data;
      this._gridLayoutManagerService.setGridColumnSubjects(this._filesPageName, data);

      if (this._gridColumns) {
        this._gridColumnsDuplicate = this._gridColumns.map(x => Object.assign({}, x));
      }
    });

    this.registerSubscription(this._gridLayoutManagerService.subscribeToColumnsChanges(this._filesPageName, (gridColumns) => {
      this._gridColumns = gridColumns;
    }));
    //---------------------------------//////////////////

    this.behavior = this._gridLayoutManagerServicelocation.subscribeToColumnsChanges2()

    this.behavior.subscribe((value: any) => {
      if (value != undefined && value != null) {
        //let pagename = value.map((a:any) => a.page).shift();
        let pagename = 'files'
        let Gridresualt = value.filter((a: any) => a.selected === true && a.page === pagename);

        switch (pagename) {
          case 'files':
            this._gridColumns = Gridresualt;
            break;

          case 'locations':
            this._gridColumns = Gridresualt;
            break;

          default:
            break;
        }
      }
    })
  }

  //#endregion

  //#region  OnInit
  ngOnInit() {
    this.route.data.subscribe((data: any) => {
      this.accessFrom = data.accessFrom;
    });

    if (this.accessFrom == 'stock') {
      this._SIQActive = true;
      this._showimageTab = false;
      this._imageTabActive = false;
    }
    else if (this.accessFrom == 'assets') {
      this._SIQActive = false;
      this._showimageTab = true;
      this._imageTabActive = true;
    }
    this._initForm();
    let windowSize = window.innerWidth;

    if (!this._currentUser.isEnterprise) {
      this._tabEnabled = true;
    }
    this._dataService.dataTransferObservable.subscribe(str => {
      if (str.isAttachment == true) {
        if (str.component == 'files') {
          this._addStockPic(str);
          this._isDialiogCategory = false;
        }
      }
    });

    var finalList: Array<any> = [];
    if (this._model && this._model.id) {
      this._categoriesService.getStockQtyInCategoryPerDate(this._model.id).subscribe((x: any) => {
        this.StockQtyInCategoryPerDate = x;
        this.StockQtyInCategoryPerDate.forEach((element) => {
          var found = false;
          finalList.forEach((el2) => {
            if (el2.dates == element.dates) {
              found = true;
              el2.quantities += element.quantities;
            }
          });
          if (!found) {
            finalList.push(element);
          }
        });
        finalList.forEach((element) => {
          this.quantities.push(element.quantities);
          this.dates.push(element.dates);
        });
      });
    }

    this.getFormTabs();
    this.getAuth();
    //this.getSystemFields();
    this.getSystemFieldsAndCustomFields();
    this._viewInactiveFormTabs(true);
    //this.setMandatoryFields();
  }
  //#endregion

  //#region  _getdata
  _getdata() {
    this._model = this._sharedService.model && this._sharedService.model.model ? this._sharedService.model.model : null;
    this._pageState = this._sharedService.model && this._sharedService.model.pageState ? this._sharedService.model.pageState : null;
    this._active = true;
    this._active2 = true;

    this._stockItemFilesPics = this._model?.categoryFiles ? this._model.categoryFiles : [];

    if ((this._pageState === PageState.ADD || this._pageState === PageState.COPY) && this._model && this._model.id > 0) {
      this.copyModelId = this._model.id;
      this._model.id = null;
      this._model.code = null;
    }

    if (this._model && this._model.id) {
      this.GetImageFromCategory(this._model);
      this.LoadStockItemQuantity();
    }
  }
  //#endregion

  //#region  GetImageFromCategory
  GetImageFromCategory(model: CategorySummary) {
    if (model.categoryFiles && model.categoryFiles.length > 0) {
      if (model.categoryFiles[0].file && model.categoryFiles[0].file.stream && model.categoryFiles[0].file.stream.length > 0) {
        let _defaultFile: CategoryFile = model.categoryFiles.find(f => f.categoryFilePrimary == true);
        this.imageUrl = _defaultFile == undefined ? model.categoryFiles[0].file.stream : _defaultFile.file.stream;
      }
    }
  }
  //#endregion

  //#region  LoadStockItemQuantity
  async LoadStockItemQuantity() {
    await this._categoriesService.GetStockItemQuantityChart(this._model.id).pipe().subscribe(async (data: any) => {
      this.stockItemQuantityChartDetail = data;
      this.stockItemQuantityChart = this.stockItemQuantityChartDetail.chart;
      this.stockItemQuantitySecondChart =
        this.stockItemQuantityChartDetail.secondChart;
    });

    this._gridFields.getGridFieldsByPage('receiveHistory').subscribe((data: any) => {
      this._gridLayoutManagerService.setGridColumnSubjects('receiveHistory', data);
      this._receiveGridColumns = data;
    });
  }
  //#endregion

  //#region _getReceivedStockItemQuantity
  _getReceivedStockItemQuantity = (params?: any, model?: any): Observable<DataWithPagingMetadata<any>> => {
    var startEndDate: any = {
      startDate: this.stockItemQuantityChartDetail.startDate,
      endDate: this.stockItemQuantityChartDetail.endDate,
    };

    return this._receieveTransactionService.GetReceiveTransactionByCategory(this._model.id, startEndDate);
  };
  //#endregion

  //#region  ngAfterContentChecked
  ngAfterContentChecked(): void {
    this.cdRef.detectChanges();
  }
  //#endregion

  _SIQChartClick(event: any) {
    if ((event.target as HTMLElement).tagName != 'DIV')
      this._SIQChartForm = true;
  }

  _closeSIQChartForm() {
    this._SIQChartForm = false;
  }

  _SIQTabClick() {
    if (this.accessFrom == 'stock') {
      this._SIQActive = true;
      this._imageTabActive = false;
    }
  }

  _imageTabClick() {
    this._imageTabActive = true;
    this._SIQActive = false;
  }
  //#region  _onEditFields
  _onEditFields() {
    if (!this._currentUser.isEnterprise) {
      this._pageState = PageState.EDIT_FIELDS;
    }
    else {
      if (!this._selectedAccounts.length) {
        this._layoutComponent.openPopup({
          title: 'Validation',
          message: 'Please choose the desired account in the Accounts Tab',
          withoutConfirm: true
        });
      }
      else {
        this._pageState = PageState.EDIT_FIELDS;
        // this._editFormActive = true;
        // this._isCustomfieldsFormValue = true;
      }
    }
  }
  //#endregion

  //#region  _openForm
  _openForm(componentName: string, isDocument = false) {
    this._dialogComponentName = componentName;
    this._dialogModel = { model: {}, pageState: PageState.ADD, isDocument, reload: 'model', fileSource: fileSources.category };
    this._isDialiogCategory = true;
  }
  //#endregion

  //#region  _reactivate
  // _viewInactiveFields() {
  //     .getDeactivatedCustomFields('stock',this._page)
  //     
  //     .subscribe((data: Array<any>) => {
  //       this._deactivatedFieldsGridData = data.filter(
  //         (x) => x.formTab.page === this._page
  //       );
  //     });
  //   this._deactivatedFieldsForm = true;
  // }
  _viewInactiveFields(onLoad: boolean = false) {
    this._customFieldsService.getDeactivatedCustomFields('stock', this._page).subscribe((data: Array<any>) => {
      this._deactivatedFieldsGridData = data.filter(x => x.formTab.page === this._page);

      // if (!onLoad)
      //   this._deactivatedFieldsForm = true;
    });
  }
  //#endregion

  _closeInactiveFields() {
    this._deactivatedFieldsForm = false;
  }

  //#region  _reactivate
  _reactivate(item: any) {
    this.reactivateItem = item;
    this.reactivate = true;
    const sub = this._sharedService.okCloseClicked.subscribe((data: boolean) => {
      if (data && this.reactivate) {
        this.reactivate = false;
        this._customFieldsService.reactivateCustomField(this.reactivateItem.id, item).subscribe((response: any) => {
          if (response != null && response['message'] != null) {
            this._layoutComponent.openPopup({
              title: 'Alert',
              message: response['message'],
              withoutConfirm: true
            });

            if (response['close'] != null) {
              if (response['close'] == true) {
                //this.loadCustomFields(this._model?.id?.toString());
                this.getSystemFieldsAndCustomFields();
                this.getFormTabs();
                this._viewInactiveFields(true);
                // this._deactivatedFieldsForm = false;
              }
              else {
                return;
              }
            }
          }

          // this._deactivatedFieldsForm = false;
        });

        // this._deactivatedFieldsForm = false;
      }
      else {
        this.reactivate = false;
      }
      sub.unsubscribe();
    });

    this._layoutComponent.openPopup({
      title: 'Notification',
      message: 'Are you sure you want to Reactivate ' + item.name,
    });
    //this.loadCustomFields(this._model?.id?.toString());
    this.getSystemFieldsAndCustomFields();
  }
  //#endregion

  _addNewTab() {
    this._editFormActive = true;
    this._isAddTabFormValue = true;
    this._isRenameLabel = false;
    this._selectedLabelId = null;
  }

  _addNewField(tabId: number) {
    this._selectedTabId = null;
    this._selectedTabId = tabId;
    this._editFormActive = true;
    this._isCustomfieldsFormValue = true;
    this._isRenameLabel = false;
    this._selectedLabelId = null;
  }

  _openRenameForm(objectCode: string, isMandatory: boolean = false) {
    this._selectedLabelObjectCode = objectCode; //todo send system field label id
    //return; //open form once label id is set

    this._editFormActive = true;
    this._isRenameFormValue = true;
    this._isRenameCustomFormValue = false;
    this._isRenameLabel = true;
    this._isMandatory = isMandatory;
  }

  _openCustomRenameForm(customFieldId: number, tabId: number) {
    this._selectedLabelId = customFieldId;
    this._selectedTabId = tabId;
    this._editFormActive = !isNaN(customFieldId);
    this._isRenameFormValue = !isNaN(customFieldId);//false;
    this._isRenameCustomFormValue = !isNaN(customFieldId);
    this._isRenameLabel = false;
    this._isMandatory = false;
  }

  _returnAdNew() {
    this._pageState = PageState.ADD;
    if (this._deactivatedFormTabsGridData?.length == 0) {
      this._viewInactiveFormTabs(true);
    }
  }

  //#region _closeCustomFields
  _closeCustomFields() {
    this._editFormActive = false;
    this._isCustomfieldsFormValue = false;
    this._isAddTabFormValue = false;
    this._isRenameFormValue = false;
    this.getSystemFieldsAndCustomFields();
    // this.loadCustomFields(this._model?.id?.toString());
    this.loadLabels();
    this.getFormTabs();
    this.getAuth();
  }
  //#endregion

  //#region  _edit
  _edit() {
    this._pageState = PageState.EDIT;
    this.accountTab.selected = true;
    this.accountTab.disabled = false;
    this.picturesTab.disabled = true;
    this.StockItemQuantityTab.disabled = true;
    this.ReceivePerCategoryTab.disabled = true;
    this.IssuePerCategoryTab.disabled = true;
    this.MovePerCategoryTab.disabled = true;
  }
  //#endregion

  //#region  Actions CirclesForm
  _openCirclesForm() {
    this._showCirclesForm = true;
    this._tooltipVisibilityUpsert = false;
  }

  _closeCirclesForm() {
    this._showCirclesForm = false;
    this._tooltipVisibilityUpsert = true;
  }
  //#endregion

  _getAccounts = (
    params?: any,
    model?: any
  ): Observable<DataWithPagingMetadata<any>> => {
    return this._accountsService.getAccounts(params, model);
  };

  _getAccountImages = (params?: any, model?: any): Observable<DataWithPagingMetadata<any>> => {
    return this._filesService.getAccountsPictures(this._selectedAccounts.map((c) => c), params, model);
  };

  _getSelectedImages = (params?: any, model?: any): Observable<DataWithPagingMetadata<any>> => {
    return this._filesService.getPictures(params, model);
  };

  _barcodeSubmited() {
    this._categoryCode.setValue(this._form.get('code').value);

    if (this._pageState == PageState.ADD) {
      setTimeout(() => {
        this.kendoInputCategoryDescription.nativeElement.focus();
        let categoryDesc = this.kendoInputCategoryDescription;
        categoryDesc.nativeElement.classList.add('focusedInput');
      });
    }
  }

  ClosePopup(event: boolean) {
    if (event == true) {
      this._closeCustomFields();
    }
  }

  CheckIfWeAreInEditMode() {
    var isEditMode: boolean = false;

    if (this._pageState == PageState.EDIT) {
      isEditMode = true;
    }

    return isEditMode;
  }

  _onStateChanges(e: any) {
    var element: any = this.kendoMainWindow;
    if (e === 'minimized') {
      element.el.nativeElement.classList.remove('fullWidthFormForm');
    }
    else if (e === 'maximized') {
      element.el.nativeElement.classList.remove('fullWidthFormForm');
    }
    else if (e === 'default') {
      element.el.nativeElement.classList.add('fullWidthFormForm');
    }
  }
  //#region  ngOnDestroy
  ngOnDestroy() {
    this._layoutManager.removeOverlay();
  }
  //#endregion

  //#region _generateBarcodeClick
  _generateBarcodeClick() {
    this.runGenerateBarcode();
  }
  //#endregion

  //#region runGenerateBarcode
  private runGenerateBarcode() {
    let counter = 1;

    this.generateBarcode(counter).subscribe((data: any) => {
      this._categoryCode.setValue(data.result.toString());
      this._form.patchValue({
        code: data.result.toString(),
      });
    });

    if (this._pageState == PageState.ADD) {
      setTimeout(() => {
        this.kendoInputCategoryDescription.nativeElement.focus();
        let CategoryDesc = this.kendoInputCategoryDescription;
        CategoryDesc.nativeElement.classList.add('focusedInput');
      });
    }
  }
  //#endregion

  //#region generateBarcode
  private generateBarcode(quantity: number) {
    return this._barcodeGeneratorsService.getBarcode('categories', quantity);
  }
  //#endregion

  //#region _skipCategoryDescription
  _skipCategoryDescription() {
    if (this._pageState == PageState.ADD) {
      let CategoryDesc = this.kendoInputCategoryDescription;
      CategoryDesc.nativeElement.classList.remove('focusedInput');
      this._addClassActive = true;
    }
  }
  //#endregion

  //#region  _removeTabActiveAndRemoveSkip
  _removeTabActiveAndRemoveSkip() {
    if (this._pageState == PageState.ADD) {
      this._addClassActive = false;
      let CategoryDesc = this.kendoInputCategoryDescription;
      CategoryDesc.nativeElement.classList.remove('focusedInput');
    }
  }
  //#endregion

  _removeTabActiveAndSkipAdd() {
    if (this._pageState == PageState.ADD) {
      this._addClassActive = false;
      let CategoryDesc = this.kendoInputCategoryDescription;
      CategoryDesc.nativeElement.classList.add('focusedInput');
    }
  }

  _CatDescSubmited() {
    if (this._pageState == PageState.ADD) {
      let CategoryDesc = this.kendoInputCategoryDescription;
      CategoryDesc.nativeElement.classList.remove('focusedInput');
      CategoryDesc.nativeElement.blur();
      this._addClassActive = true;
    }
  }

  _CatDescFocusout() {
    if (this._pageState == PageState.ADD) {
      setTimeout(() => {
        let CategoryDesc = this.kendoInputCategoryDescription;
        CategoryDesc.nativeElement.classList.remove('focusedInput');
        CategoryDesc.nativeElement.blur();
      }, 100);
    }
  }

  @HostListener('window:resize', ['$event'])
  onResize(event: any) {
    this._innerWidth = window.innerWidth;

    if (this._innerWidth > 450) {
      this._hiddenWindow = 'hidden';
      this._maximized = 'maximized';
    }
    else {
      this._hiddenWindow = '';
      this._maximized = 'default';
    }

    let windowSize = window.innerWidth;

    if (windowSize <= 991) {
      this._kendoTabStripPosition = 'top';
    }
    else {
      this._kendoTabStripPosition = 'left';
    }
  }

  getCategoryImagePath(path: any): any {
    var PrimaryImage = '';

    PrimaryImage = EnvironmentLoaderService.envConfig.enterpriseApiLocal + '/' + path;
    //return EnvironmentLoaderService.envConfig.enterpriseApiLocal+'/'+ element.file.thumbnail;
    return PrimaryImage;
  }

  _selectImagesHandler(e: any): void {
    if (this._currentUser.isEnterprise) {
      if (this._selectedAccounts.length) {
        this._showImagesGrid = true;
      } else {
        this._layoutComponent.openPopup({
          title: 'Validation',
          message: 'Please choose the account with the site desired',
          withoutConfirm: true
        });
      }
    }
    else if (!this._currentUser.isEnterprise) {
      this._showImagesGrid = true;
    }
  }

  _returnSelectedImagesHandler(e: any): void {
    if (this._currentUser.isEnterprise) {
      if (this._selectedAccounts.length) {
        this._showImagesGrid = false;
        let currentSelected = this._selectedImagesKeys.concat(this._selectedImages);
        this._selectedImagesKeys = currentSelected.filter((c, index) => {
          return currentSelected.indexOf(c) === index;
        });
      }
      else {
        this._layoutComponent.openPopup({
          title: 'Validation',
          message: 'Please choose the account with the site desired',
          withoutConfirm: true
        });
      }
    }
    else if (!this._currentUser.isEnterprise) {
      this._showImagesGrid = false;
      let currentSelected = this._selectedImagesKeys.concat(this._selectedImages);
      this._selectedImagesKeys = currentSelected.filter((c, index) => {
        return currentSelected.indexOf(c) === index;
      });
    }

    this._addStockPic();
  }

  _onTabSelect(e: any) {
    this._mobileMenuToggle();
    if (this._currentUser.isEnterprise) {
      if (!this._selectedAccounts.length) {
        this._layoutComponent.openPopup({
          title: 'Validation',
          message: 'Please choose the account with the site desired',
          withoutConfirm: true
        });
        e.preventDefault();
        return;
      }
    }
    else if (!this._currentUser.isEnterprise) {
      //e.preventDefault();
    }
  }

  _mobileMenuToggle() {
    let mobiletabstrip = this.navTrigger.nativeElement.querySelector('ul');
    mobiletabstrip.classList.toggle('visibletab');
  }

  _closeImagesWindow(): void {
    this._showImagesGrid = false;
  }

  _onImageRowSelectionChanges(e: any[]) {
    this._selectedImages = [];
    e.forEach((item) => {
      this._selectedImages.push(+item);
    });
  }

  _onImageObjectRowSelectionChanges(e: any[]) {
    this._selectedObjectImages = [];
    this._selectedObjectImages = e;
  }
  //#region  _addStockPic
  _addStockPic(fileData: any = null) {
    this._stockItemFilesPics = this._stockItemFilesPics || [];

    if (fileData == null) {
      if (this._selectedObjectImages.length > 0) {
        this._selectedObjectImages.forEach((element: any) => {
          let exists = this._stockItemFilesPics.find((f) => f.fileId == element.id);

          if (exists == undefined) {
            delete element.fileAccounts;

            let stockItemFile: CategoryFile = new CategoryFile();
            stockItemFile.fileId = element.id;
            stockItemFile.fileName = element.name;
            stockItemFile.file = element;
            stockItemFile.categoryId = this._model?.id ? this._model.id : 0;
            stockItemFile.status = EntityStatusOptions.Active;
            this._stockItemFilesPics.push(stockItemFile);
          }
        });
        this._stockItemFilesPics = [...this._stockItemFilesPics];
        this.cdRef.detectChanges();
      }
    }
    else {
      const fileId = fileData.picObject?.id || fileData.response?.id || fileData.id;
      if (fileId) {
        let exists = this._stockItemFilesPics.find((f) => f.fileId == fileId);
        if (exists == undefined) {
          let stockItemFile: CategoryFile = new CategoryFile();
          stockItemFile.fileId = fileId;
          stockItemFile.fileName = fileData.picObject?.name || fileData.response?.name || '';
          stockItemFile.file = fileData.picObject?.file || fileData.response?.fileElement || fileData.picObject || null;
          stockItemFile.categoryId = this._model?.id ? this._model.id : 0;
          stockItemFile.status = EntityStatusOptions.Active;

          this._stockItemFilesPics = [...this._stockItemFilesPics, stockItemFile];

          if (!this._selectedImagesKeys.includes(fileId)) {
            this._selectedImagesKeys = [...this._selectedImagesKeys, fileId];
          }

          this._filesService.getFile(fileId).subscribe((data: any) => {
            if (data) {
              stockItemFile.file = data;
              stockItemFile.fileName = data.name;
              this._stockItemFilesPics = [...this._stockItemFilesPics];
              this.cdRef.detectChanges();
            }
          });

          this.cdRef.detectChanges();
        }
      }
    }
  }
  //#endregion

  //#region _removePicHandler
  _removePicHandler(event: any) {
    const index = this._stockItemFilesPics.indexOf(event, 0);

    if (index > -1) {
      this._stockItemFilesPics.splice(index, 1);
      this._stockItemFilesPics = [...this._stockItemFilesPics];
      const keyIndex = this._selectedImagesKeys.indexOf(event.fileId);
      if (keyIndex > -1) {
        this._selectedImagesKeys.splice(keyIndex, 1);
        this._selectedImagesKeys = [...this._selectedImagesKeys];
      }
      this.cdRef.detectChanges();
    }
  }
  //#endregion
  _setPrimaryPic(data: any) {
    this._stockItemFilesPics.forEach((element: any) => {
      if (element !== data) {
        element.categoryFilePrimary = false;
      }
    });
  }

  //#region  Form Actions
  _onSave(e: any) {
    this.submit(e);
  }

  _onEditForm() { }

  _onCancel() {
    this._closeForm();
  }

  reloadlist: any;
  _closeForm(poModel: any = null) {

    this.reloadlist = this._sharedService.model.reload;
    var closeComponent = {
      component: 'categories',
      isClosed: true,
      response: this.reloadlist === undefined ? null : poModel,
      retCategory: poModel
    };

    this._gridLayoutManagerService.setGridDataSubjects('categories');
    this._layoutManager.setFromChanged('categories');
    this.ngOnDestroy();
    this._sharedService.closeDialog.emit(closeComponent);
    this._sharedService.model = {};
    //Quraim
    this._dataService.push(closeComponent);
    this._sharedService.model = {};
  }
  //#endregion

  _onAccountRowSelectionChanges(e: any[]) {
    super._onAccountRowSelectionChanges(e);
  }

  private _initForm() {
    this._form = this._fb.group({
      code: [this._model && this._model.code, Validators.required],
      description: [
        this._model && this._model.description,
        this.getLabel('LBL_CatDesc')?.isRequired ? Validators.required : null,
      ],
    });
  }

  _additionalErrors: any = [];

  //#region  submit
  private submit = (e: string) => {
    var sitesSelected: boolean = true;
    if (this._currentUser.isEnterprise) {
      if (this._currentUser.isEnterprise && this._selectedAccounts.length === 0) {
        this._layoutComponent.openPopup({
          title: 'Validation',
          message: 'Please select account(s) to continue.',
        });

        return false;
      }
      else {
        var tmpAccountSites = this._selectedAccounts.filter((x: any) => x.siteId != -1);

        if (tmpAccountSites.length != this._selectedAccounts.length) {
          this._layoutComponent.openPopup({
            title: 'Validation',
            message: 'Please select the site(s) of the selected account(s) to continue.',
          });
          sitesSelected = false;
          return false;
        }
      }
    }

    if (this._form.invalid && this._customValidation.find((x: any) => !x.value)) {
      this._additionalErrors.push("Additional Error");
      this._additionalErrors = [];
      this._invalidForm = true;
      this._invalidSubmit = true;
    }
    else if (this._form.invalid) {
      this._invalidForm = true;
    } //else if (this._custominvalidForm && this._customValidation.find((x: any) => !x.value) )
    else if (this._customValidation.find((x: any) => !x.value)) {
      this._additionalErrors.push("Additional Error");
      this._additionalErrors = [];
      this._invalidSubmit = true;
      this._invalidForm = true;
    }
    else {
      // work with custom fields
      // if (this._customFieldsValue) {
      //   const entries = Object.entries(this._customFieldsValue);
      //   for (const [index, [key, value]] of entries.entries()) {
      //     this._customFieldsDictionary[key] = `${value}`;
      //   }
      // }
      //
      this._invalidForm = false;
      this._invalidSubmit = false;
      const model = this._form.value;

      if (this._customFieldsValue) {
        this._customFieldsValue.forEach((elementy: any) => {
          this._customFieldsDictionary[elementy.Key] = elementy.Value;
        });
      }

      model['customFieldsValue'] = this._customFieldsDictionary;
      model['accountIds'] = this._selectedAccounts.map((c: any) => (c?.accountId != null ? +c.accountId : +c));
      // model['fileIds'] = this._selectedImagesKeys;
      model['categoryFiles'] = this._stockItemFilesPics;
      if (this._pageState == PageState.EDIT || this._pageState == PageState.VIEW) {

        this._categoriesService.updateCategory(this._model.id, model).subscribe((response: any) => {
          if (response != null && response['message'] != null) {
            this._layoutComponent.openPopup({
              title: 'Alert',
              message: response['message'],
              withoutConfirm: true
            });

            if (response['close'] != null) {
              if (response['close'] == true) {
                model.id = this._model.id;
                this._categoriesService.categoryUpdated.emit(model);
                if (e === 'saveAndClose') {
                  this._closeForm(response);
                }
                else if (e === 'saveAndCopy') {
                  this.copyModelId = this._model.id;
                  this._pageState = PageState.ADD;
                  this._form.controls.code.setValue(null);
                  this.loadCustomFields();
                }
                else if (e === 'saveAndNew') {
                  this.openUpsert(this._page, {}, PageState.ADD);
                  //this._closeForm();
                }

              }
              else {
                return;
              }
            }
          }
          // this._closeForm();
        });
      }
      else {
        this._categoriesService.createCategory(model).subscribe((response: any) => {
          if (response != null && response['message'] != null) {
            if (!this._currentUser.isEnterprise) {
              this.note.createNote(response.responseId);
            }

            this._layoutComponent.openPopup({
              title: 'Alert',
              message: response['message'],
              withoutConfirm: true
            });

            if (response['close'] != null) {
              if (response['close'] == true) {
                model.id = response.responseId;
                this._categoriesService.categoryAdded.emit(model);

                if (e === 'saveAndClose') {
                  model.id = response.responseId;
                  this._closeForm(model);
                  //   this._closeForm(response);
                }
                else if (e === 'saveAndCopy') {
                  this.copyModelId = this._model.id;
                  this._form.controls.code.setValue(null);
                  // this.loadCustomFields();
                }
                else if (e === 'saveAndNew') {
                  this.openUpsert(this._page, {}, PageState.ADD);
                  //this._closeForm();
                }
                else if (e === 'save') {
                  this._pageState = PageState.EDIT;
                  this._model.id = response.responseId;
                }
              }
              else {
                return;
              }
            }
          }
          // this._closeForm();
        });
      }
    }
  };
  //#endregion
  //#region  loadCustomFields
  private loadCustomFields(entityId?: string) {
    entityId = this.copyModelId?.toString() ?? this._model?.id?.toString();
    this._customFieldsService.getCustomFields('stock', this._page, entityId).subscribe((data) => {
      if (this._model != null && this._model.id != null || this.copyModelId != null) {
        let that = this;
        data.map(function (x) {
          x.entityId = that._model.id ?? that.copyModelId;
        });
      }

      var tabIds = data.map((item) => item.formTabId).filter((value, index, self) => self.indexOf(value) === index);

      const grouped = this.groupBy(data, (item: { formTabId: any }) => item.formTabId);
      let that = this;

      tabIds.forEach(function (formTabId) {
        that._customFields[formTabId] = grouped.get(formTabId);
      });

      if (this.copyModelId) {
        let CustomFieldsDataForCopy: any = {};
        grouped.forEach(element => {
          element.forEach((value: any) => {
            let _cutomfieldData = value.customFieldsData?.find((f: any) => f.entityId == entityId);
            CustomFieldsDataForCopy[value.name] = _cutomfieldData?.value ?? null;

            if (value.customFieldType.type.toLowerCase() == 'date' && CustomFieldsDataForCopy[value.name]) {
              CustomFieldsDataForCopy[value.name] = new Date(CustomFieldsDataForCopy[value.name]);
            }

            if (value.customFieldType.type.toLowerCase() == 'numeric' && CustomFieldsDataForCopy[value.name]) {
              CustomFieldsDataForCopy[value.name] = parseFloat(CustomFieldsDataForCopy[value.name]);
            }

          });

          this._customFieldsValueChanges(CustomFieldsDataForCopy, null);
        });
      }

      this._customFieldsService.getFormTabsByPage(this._page).subscribe((data: any) => {
        //get custom tabs first
        this._customTabs = data.filter(
          (x: { isCustom: boolean }) => x.isCustom == true
        );
        this.setMandatoryFields();
      });
    });
  }
  //#endregion
  //#region  groupBy
  groupBy(list: any[], keyGetter: any) {
    const map = new Map();
    list.forEach((item) => {
      const key = keyGetter(item);
      const collection = map.get(key);

      if (!collection) {
        map.set(key, [item]);
      }
      else {
        collection.push(item);
      }
    });

    return map;
  }
  //#endregion
  //#region  _customFieldsValueChanges
  _customFieldsValueChanges(customFieldsValue: any, tabId: number) {
    Object.keys(customFieldsValue).forEach((key) => {
      let customObject = {
        Key: key,
        Value: customFieldsValue[key],
      };

      let item = null;
      this._customFieldsValue.forEach((elementz: any) => {
        if (elementz.Key == key) {
          item = elementz;
        }
      });

      if (item != null) {
        let index = this._customFieldsValue.indexOf(item);
        if (index != -1) {
          this._customFieldsValue.splice(index, 1);
        }
      }

      var requiredCustomerField = this._customValidation.find((x: any) => x.name == key);

      if (requiredCustomerField) {
        let item2 = null;
        this._customValidation.forEach((element: any) => {
          if (element.name == key) {
            item2 = element;
          }
        });

        if (item2 != null) {
          let index2 = this._customValidation.indexOf(item2);

          if (index2 != -1) {
            //this._customValidation.splice(index2, 1);
            this._customValidation[index2].value = customObject.Value;
          }
          //this._customValidation.push({'name': customObject.Key, 'value': customObject.Value})
        }
      }

      this._additionalErrors = [];

      if (this._customValidation.find((x: any) => !x.value)) {
        this._additionalErrors.push("Additional Error");
        this._additionalErrors = [];
      }

      this._customFieldsValue.push(customObject);
    });
  }
  //#endregion
  //#region  _removeCustomField
  _removeCustomField(customFieldId: number) {
    for (var i = 1; i <= this._customFields.length; i++) {
      if (this._customFields[i] != null) {
        if (this._customFields[i].findIndex((x) => x.id == customFieldId) != -1) {
          this._customFields[i] = this._customFields[i].filter((x) => x.id != customFieldId);
          this.setMandatoryFields();
          this._viewInactiveFields(true);

          return;
        }
      }
    }
  }
  _viewInactiveFormTabs(onLoad: boolean = false) {
    this._customFieldsService
      .getDeactivatedCustomForms(this._page)

      .subscribe((data: Array<any>) => {
        this._deactivatedFormTabsGridData = data;
        //  if(!onLoad)
        //  this._deactivatedFormTabsForm = true;
      });
  }
  reactivateTab: boolean;
  _reactivateFormTab(item: any) {
    this.reactivateTab = true;
    const sub = this._sharedService.okCloseClicked.subscribe((boolData: boolean) => {
      this.reactivateTab = true;
      if (boolData && this.reactivateTab) {
        // if (boolData && this.reactivateTab && (this.lastTabIdReactivated.length == 0 || !this.lastTabIdReactivated.includes(item.id))) {
        this.reactivateTab = false;
        let model: any = {
          customFieldEntityId: 1,
          page: this._page,
          accountIds: this._selectedAccountIds,
        };
        this._customFieldsService
          .reactivateFormTab(item.id, model)

          .subscribe((response: any) => {
            if (response != null && response['message'] != null) {
              // if (this.lastTabIdDeactivated.includes(item.id)) {
              //   this.lastTabIdDeactivated = this.lastTabIdDeactivated.filter(id => id !== item.id);
              // }
              // this.lastTabIdReactivated.push(item.id);
              this._viewInactiveFormTabs(false)
              this._customFieldsService
                .getFormTabsByPage(this._page)

                .subscribe((data: any) => {
                  //get custom tabs first
                  this.getFormTabs();
                  this._customTabs = data.filter((x: { isCustom: boolean; }) => x.isCustom == true);
                });
              this._layoutComponent.openPopup({
                title: 'Alert',
                message: response['message'],
                withoutConfirm: true
              });
              if (response['close'] != null) {
                if (response['close'] == true) {
                } else {
                  return;
                }
              }
            }
          });
      } else {
        this.reactivateTab = false;
      }
      sub.unsubscribe();
    });


    this._layoutComponent.openPopup({
      title: 'Notification',
      message: 'Are you sure you want to Reactivate ' + item.name
    });
    //this.loadCustomFields(this._model?.id?.toString());
    this.getSystemFieldsAndCustomFields();
  }
  _closeInactiveFormTabs() {
    this._deactivatedFormTabsForm = false;
  }
  // lastTabIdDeactivated:number[] = []
  // lastTabIdReactivated:number[] = []
  //#endregion
  deactivateTab: boolean
  _deactivateTab(tabId: number, page: string) {
    this.deactivateTab = true;
    const sub = this._sharedService.okCloseClicked.subscribe((boolData: boolean) => {
      if (boolData && this.deactivateTab) {
        // if (boolData && this.deactivateTab && (this.lastTabIdDeactivated.length == 0 || !this.lastTabIdDeactivated.includes(tabId))) {
        this.deactivateTab = false;
        let model: any = {
          customFieldEntityId: 1,
          page: this._page,
          accountIds: this._selectedAccountIds,
        };
        this._customFieldsService.deleteCustomTab(tabId, model).subscribe((response: any) => {
          // this.lastTabIdDeactivated.push(tabId);
          // if (this.lastTabIdReactivated.includes(tabId)) {
          //   this.lastTabIdReactivated = this.lastTabIdReactivated.filter(id => id !== tabId);
          // }

          if (response != null && response['message'] != null) {
            this._customFieldsService.getFormTabsByPage(this._page).subscribe((data: any) => {
              //get custom tabs first
              this.getFormTabs();
              this._customTabs = data.filter((x: { isCustom: boolean }) => x.isCustom == true);
            });

            this._layoutComponent.openPopup({
              title: 'Alert',
              message: response['message'],
              withoutConfirm: true
            });

            if (response['close'] != null) {
              if (response['close'] == true) {
                // this._closeForm();
              }
              else {
                return;
              }
            }
          }
        });
      } else {
        this.deactivateTab = true;
      }
      sub.unsubscribe();
    });

    this._layoutComponent.openPopup({
      title: 'Notification',
      message: 'Are you sure you want to Deactivate This Tab?',
    });

  }

  //#region  _deactivateTab
  // _deactivateTab(tabId: number, page: string) {
  //   let model: any = {
  //     customFieldEntityId: page == 'categories' ? 1 : 2,
  //     page: this._page,
  //     accountIds: this._selectedAccountIds,
  //   };

  //     if (response != null && response['message'] != null) {

  //         //get custom tabs first
  //         this.getFormTabs();

  //         this._customTabs = data.filter((x: { isCustom: boolean }) => x.isCustom == true);

  //       });

  //       this._layoutComponent.openPopup({
  //         title: 'Alert',
  //         message: response['message'],
  //         withoutConfirm: true
  //       });

  //       if (response['close'] != null) {
  //         if (response['close'] == true) {
  //           // this._closeForm();
  //         }
  //         else {
  //           return;
  //         }
  //       }
  //     }
  //     //   this._closeForm();
  //   });
  // }
  //#endregion
  //#region  getLabel
  getLabel(objectCode: any) {
    if (this._gridFieldText) {
      if (this._gridFieldText.find(({ gridFieldDefinition }) => gridFieldDefinition?.objectCode === objectCode)) {
        var result = this._gridFieldText.find(({ gridFieldDefinition }) => gridFieldDefinition?.objectCode === objectCode);
      }
      else {
        result = null;
      }

      return result ? result : null;
    }
  }
  //#endregion
  //#region loadLabels
  private loadLabels() {
    this._gridFields.getGridFieldTextLabelByPage(this._page, this._language).subscribe((data: GridFieldTextSummary[]) => {
      this._gridFieldText = data;
      this._initForm();
    });
  }
  //#endregion

  formStatus(isInvalid: boolean) {
    this._custominvalidForm = isInvalid;
  }

  _reorderingtabs() {
    this._orderingTabsForm = true;
  }
  _closeOrderingTabsForm() {
    this._orderingTabsForm = false;
    this._dataTabsSelected = this._userNewDataTabs;
  }

  _comboValueChange(e: any, i: number) {
    if (this._dataTabsSelected.find((x) => x.order == i + 1)) {
      this._userNewDataTabs.find((x) => x === this._dataTabsSelected.find((x) => x.order == i + 1)).order = this._dataTabsSelected.find((x) => x.name === e.name).order;
    }

    this._userNewDataTabs.find((obj) => obj.name == e.name).order = i + 1;
    this._dataTabsSelected = this._dataTabsSelected.filter((obj) => obj !== e);
  }

  _onSaveTabOrdering() {
    this._gridFields.updateFormTabsReorder(this._userNewDataTabs).subscribe((x: any) => {
      this._dataTabs = x;
      this._closeOrderingTabsForm();
    });
  }

  getFormTabs() {
    this._gridFields.getformTabsByPage(this._page).subscribe((x: any) => {
      this._dataTabs = x;
      this._dataTabsSelected = x;
      this._userNewDataTabs = x;
      //this.sortProduct(p => p.order, "ASC");
    });
  }

  getSystemFields() {
    this._gridFields.getSystemFieldsByPage(this._page).subscribe((x: any) => {
      this._systemFields = x;
      this._editedSystemFields = x;
    });
  }

  getSystemFieldsAndCustomFields() {
    this._gridFields.getSystemFieldsByPage(this._page).subscribe((x: any) => {
      this._systemFields = x;
      this._editedSystemFields = x;
      this.loadCustomFields(this._model?.id?.toString());
      //this.setMandatoryFields();
    })
  }

  getAuth() {
    // this._gridFields.getFileAuthorization(this._auth, this._currentUser.appRole.id)
    this._gridFields
      .getFieldsAuthorization(this._page, this._currentUser.appRole.id)

      .subscribe((x: GridFieldAuthorization[]) => {
        this._gridFieldAuth = x;
      });
  }

  getAuthByLabel(objectCode: any) {
    if (this._gridFieldAuth) {
      if (
        this._gridFieldAuth.find(
          ({ gridFieldDefinition }) =>
            gridFieldDefinition?.objectCode === objectCode
        )
      )
        var result = this._gridFieldAuth.find(
          ({ gridFieldDefinition }) =>
            gridFieldDefinition?.objectCode === objectCode
        );
      else result = null;

      return result ? result : new GridFieldAuthorization();
    }
  }
  requiredSystemTabs: any = [];
  // setMandatoryFields() {
  //   this._requiredFieldNames = [];
  //   this._requiredFields = [];
  //   this.requiredSystemTabs = [];
  //   setTimeout(() => {
  //     for (let item of this._systemFields) {
  //       if (item.gridFieldText.isRequired) {
  //         this._requiredFields.push(item);
  //       }
  //     }

  //     for (let item2 of this._customFields) {
  //       if (item2) {
  //         for (let item3 of item2) {
  //           if (item3.isRequired) {
  //             this._requiredFields.push(item3);
  //           }
  //         }
  //       }
  //     }

  //     this._requiredFields.forEach((element) => {
  //       if (!element.isCustomField && element.isCustomField == null) {
  //         var tabName = element.formTab;
  //         this._requiredFieldNames.push(tabName);
  //       }
  //       else
  //       {
  //         if(element.formTabId)
  //         {
  //           let SystemFieldTab = this._dataTabs.find(x => x.id == element.formTabId);
  //           if(SystemFieldTab)
  //           this.requiredSystemTabs.push(SystemFieldTab);
  //         }
  //       }
  //     });

  //     let tabElementList = this.navTrigger.nativeElement.querySelector('ul');
  //     Array.from(tabElementList.children).forEach((child: any) => {

  //       child.classList.remove('mendatoryTab');
  //   });
  //     Array.from(tabElementList.children).forEach((child: any) => {
  //       if (
  //         this._requiredFieldNames.find(
  //           (x) => x.name === child.firstChild.innerText
  //         )
  //       ) {
  //         child.classList.add('mendatoryTab');
  //       }
  //       if (
  //         this.requiredSystemTabs.find(
  //           (x : any) =>
  //             x.name === child.firstChild.innerText
  //         )
  //       ) {
  //         child.classList.add('mendatoryTab');
  //       }
  //     });
  //   }, 500);
  // }
  setMandatoryFields() {

    //this.getSystemFields();
    //this.loadCustomFields(this._model?.id?.toString());
    this._requiredFieldNames = [];
    this._requiredFields = [];
    this.requiredSystemTabs = [];
    this._customValidation = [];
    setTimeout(() => {
      for (let item of this._systemFields) {
        if (
          item.gridFieldText?.isRequired &&
          item.page?.trimEnd('') == this._page
        ) {
          this._requiredFields.push(item);
        }
      }

      for (let item2 of this._customFields) {
        if (item2) {
          for (let item3 of item2) {
            if (item3.isRequired && item3.formTab?.page == this._page) {
              this._requiredFields.push(item3);
            }
          }
        }
      }

      this._requiredFields.forEach((element) => {

        if (!element.isCustomField && element.isCustomField == null) {
          var tabName = element.formTab;
          this._requiredFieldNames.push(tabName);
        }
        else {
          if (element.formTabId) {
            let SystemFieldTab = this._dataTabs.find(x => x.id == element.formTabId);
            if (SystemFieldTab)
              this.requiredSystemTabs.push(SystemFieldTab);
          }
        }
      });

      let tabElementList = this.navTrigger.nativeElement.querySelector('ul');


      Array.from(tabElementList.children).forEach((child: any) => {

        child.classList.remove('mendatoryTab');
      });


      Array.from(tabElementList.children).forEach((child: any) => {
        if (child.firstChild.innerText == 'General') {
          child.classList.add('mendatoryTab');
        }
        if (child.firstChild.innerText == 'Costing') {
          child.classList.add('mendatoryTab');
        }
        if (
          this._requiredFieldNames.find(
            (x) =>
              x.name === child.firstChild.innerText &&
              (x.page
                ? x.page.trimEnd('') == this._page
                : x.formTab.page.trimEnd('') == this._page)
          )
        ) {
          child.classList.add('mendatoryTab');
        }
        if (
          this.requiredSystemTabs.find(
            (x: any) =>
              x.name === child.firstChild.innerText
          )
        ) {
          child.classList.add('mendatoryTab');
        }
      });


      this._requiredFields.forEach((element) => {
        if (element.customFieldType) {
          this._customRequiredFields.push(element);
          let thisvalue =
            element.customFieldsData.filter(
              (x: any) => x.entityId == (this._model.id > 0 ? this._model.id : this.copyModelId)
            ).length > 0
              ? element.customFieldsData.filter(
                (x: any) => x.entityId == (this._model.id > 0 ? this._model.id : this.copyModelId)
              )[0].value
              : '';
          this._customValidation.push({
            name: element.name,
            value: thisvalue,
            tabName: element.formTab?.name,
          });
        }
      });
    }, 500);
  }

  _onEditForms() {
    this._isEditForms = true;
  }

  _onCloseEditForms(event: boolean) {
    this._isEditForms = event;
  }

  openUpsert(componentName: string, model: any, pageState: PageState) {
    this._isDialiogCategory = true;
    this._dialogComponentName = componentName;
    this._dialogModel = { model, pageState };
  }

  _closeDialog(event: any) {
    this._isDialiogCategory = false;
  }

  GetImageById(id: number) {
    this._filesService.getFile(id).pipe().subscribe((data) => {
      var categoryFile = new CategoryFile();
      categoryFile.file = data;

      this._stockItemFilesPics.push(categoryFile);
    });
  }

  ExpandCollapseStockItemGrid(isExpand: boolean) {
    this.isStockItemGridExpanded = !isExpand;
  }

  ExpandCollapseStockItemChart(isExpand: boolean) {
    this.isStockItemChartExpanded = !isExpand;
  }

  canAccess(scope: string, operation: string): boolean {
    return this._securityService.hasPermission(null, `${scope}-${operation}`);
  }


}
